var _path, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderSearchDuotone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 11.666H27.425C28.5451 11.666 29.1052 11.666 29.533 11.884C29.9093 12.0757 30.2153 12.3817 30.407 12.758C30.625 13.1859 30.625 13.7459 30.625 14.866V25.966C30.625 27.0861 30.625 27.6462 30.407 28.074C30.2153 28.4503 29.9093 28.7563 29.533 28.948C29.1052 29.166 28.5451 29.166 27.425 29.166H7.575C6.4549 29.166 5.89484 29.166 5.46702 28.948C5.09069 28.7563 4.78473 28.4503 4.59299 28.074C4.375 27.6462 4.375 27.0861 4.375 25.966V11.666Z",
    fill: "#1B9FBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 11.291C4.375 9.4054 4.375 8.46259 4.96079 7.8768C5.54657 7.29102 6.48938 7.29102 8.375 7.29102H12.9265C13.744 7.29102 14.1527 7.29102 14.5203 7.44326C14.8878 7.5955 15.1768 7.88453 15.7549 8.46259L18.9583 11.666H4.375V11.291Z",
    fill: "#1B9FBC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7708,
    cy: 19.6868,
    r: 3.14583,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4165 23.334L22.604 25.5215",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSearchDuotone);
export default __webpack_public_path__ + "static/media/folder_search_duotone.59916c6ff686aa3de71598881e748d7c.svg";
export { ForwardRef as ReactComponent };